module.exports = __webpack_public_path__ + "static/media/iphone.efea0e7d.png";